import * as React from "react";
import { observable, computed, toJS } from 'mobx';
import { observer, inject } from "mobx-react";
import { AsyncCreatable as  AsyncCreatableSelect } from 'react-select';

import debounce from '@utils/debounce';
import Modal from "@components/Modal/modal"

@inject("store")
@observer
export default class UserEdit extends React.Component {
    @observable userOptions = [];
    @observable selectedAccountOption = null;
    @observable account = null;
    @observable showAddCustomers = false;
    @observable showSendEmail = false;
    @observable customerSearchValue = "";
    @observable customerSearchResult = [];
    @observable message = "";
    @observable sendInvitationButton = { text: "Send invitation email", disabled: false }

    constructor(props) {
        super(props);
        this.searchAccount = this.searchAccount.bind(this);
        this.getAccount = this.getAccount.bind(this);
        this.onChangeRole = this.onChangeRole.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.saveAccount = this.saveAccount.bind(this);
        this.addCustomers = this.addCustomers.bind(this);
        this.handleCustomerSearchValue = this.handleCustomerSearchValue.bind(this);
        this.performCustomerSearch = debounce(this.performCustomerSearch.bind(this), 350);
        this.toggleCompany = this.toggleCompany.bind(this);
        this.toggleAddress = this.toggleAddress.bind(this);
        this.hideAddCustomers = this.hideAddCustomers.bind(this);
        this.isSelected = this.isSelected.bind(this);
        this.deleteCustomer = this.deleteCustomer.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.isValidNewOption = this.isValidNewOption.bind(this);
        this.addAccount = this.addAccount.bind(this);
        this.creatableRef = null;
        this.toggleSendEmail = this.toggleSendEmail.bind(this);

        this.updateMessage = this.updateMessage.bind(this);
        this.sendInvitation = this.sendInvitation.bind(this);
        this.MODAL_OPEN_CLASS = "modal-open";
    }

    componentDidMount() {
        //document.body.classList.add(this.MODAL_OPEN_CLASS);
    }

    componentWillUnmount() {
        //document.body.classList.remove(this.MODAL_OPEN_CLASS);
    }

    async searchAccount(input) {
        const accountStore = this.props.store.account;
        const users = await accountStore.searchUsers(input);
        return users.map(opt => ({ label: opt.Name + ", " + opt.Email, value: "" + opt.Id, email: opt.Email }));
    }

    async getAccount(userId) {
        const accountStore = this.props.store.account;
        this.account = await accountStore.getAccountById(userId);
    }

    async addAccount(email) {
        const accountStore = this.props.store.account;
        this.account = await accountStore.addAccount(email);
    }




    onChangeRole(key, value) {
        //console.debug(key, value);

        if (this.account) {
            // Find customer
            const customer = this.account.Customers.find(x => x.Id === key);
            customer.Role = value;
            //customer.Role = customer.Role === "admin" ? "" : "admin";
        }

        this.saveAccount();
    }

    resetForm() {
        this.selectedAccountOption = null;
        this.account = null;
        this.showAddCustomers = false;
        this.showSendEmail = false;
        this.customerSearchResult = [];
        this.customerSearchValue = "";
        this.message = "";
    }

    toggleSendEmail() {
        this.showSendEmail = !this.showSendEmail;
    }

    updateMessage(e) {
        this.message = e.target.value;
    }

    sendInvitation() {

        this.showSendEmail = false;
        this.sendInvitationButton = { text: "*Sending...*", disabled: true };


        this.props.store.account.inviteUser(this.account.UserId, this.account.Email, this.message).then(
            () => {
                this.sendInvitationButton = { text: <span key="mailSent">Email sent<i className="material-icons check"></i></span>, disabled: true };
            });
    }

    async saveAccount() {
        const account = toJS(this.account);
        //console.debug("account", account);
        const accountStore = this.props.store.account;
        this.account = await accountStore.editAccount(account);

    }

    addCustomers() {
        this.showAddCustomers = true;
    }

    hideAddCustomers() {
        this.showAddCustomers = false;
        this.customerSearchValue = "";
        this.customerSearchResult = [];
    }

    handleCustomerSearchValue(e) {
        this.customerSearchValue = e.target.value;
        //console.debug(this.customerSearchValue);


        if (this.customerSearchValue.length < 3) {
            this.customerSearchResult = [];
            return;
        }
        this.performCustomerSearch(this.customerSearchValue);
    }

    async performCustomerSearch(searchValue) {
        const result = await this.props.store.account.searchCustomer(searchValue);
        this.customerSearchResult = result.Customers;

        //console.debug("performCustomerSearch", this.customerSearchResult);
    }



    toggleCompany(company) {
        // Add company as "dirty" to this.account.Customers
        const c = this.account.Customers.find(x => x.Id === company.Id);

        if (!c) {
            const newCompanyItem = { 
                Name: company.Name, 
                Id: company.Id, 
            };
            this.account.Customers.push(newCompanyItem);
            this.account.Customers.replace(this.account.Customers.slice().sort((a, b) => b.Name < a.Name));
        }

        this.saveAccount();
    }


    toggleAddress(address) {
        address.Active = !address.Active;
        this.saveAccount();
    }



    deleteCustomer(customer) {
        const c = this.account.Customers.find(x => x.Id === customer.Id);
        if (c !== undefined) {
            this.account.Customers.remove(c);
        }
        this.saveAccount();
    }

    isSelected(company) {
        const c = this.account.Customers.find(x => x.Id === company.Id);
        return (c !== undefined);
    }


    isValidNewOption(inputValue, selectValue, selectOptions) {
        //console.debug(selectOptions, inputValue);
        if (
            inputValue.trim().length === 0 ||
            selectOptions.find(option => option.email === inputValue)
        ) {

            return false;
        }

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(inputValue).toLowerCase());

    }


    getNewOptionData(inputValue, optionLabel) {
        return {
            value: inputValue,
            label: optionLabel
        };
    }

    handleCreate(option, obj) {
        //console.debug("handleCrete:", option, obj);
        //console.debug(this.userOptions);
    }

    render() {

        return (
            <div style={{ minHeight: 500, width: "100%" }}>
                <h6 className="text-muted text-normal text-uppercase">Search or create user to edit</h6>
                <div >

                    <AsyncCreatableSelect
                        getNewOptionData={this.getNewOptionData}

                        formatCreateLabel={(value) => {
                            return <div>Create new user: <strong>{value}</strong></div>;
                        }}

                        isValidNewOption={this.isValidNewOption}
                        loadOptions={debounce((input, callback) => {
                            this.searchAccount(input).then(result =>
                                callback(result)).catch(err => callback(err));
                        }, 250)}
                        noOptionsMessage={() => { return "Search existing or type a new email address" }}
                        placeholder="Enter email address"
                        isClearable={true}
                        autoFocus={true}
                        onChange={(option, { action }) => {
                            switch (action) {
                                case 'select-option':
                                    console.debug("select", option);
                                    this.getAccount(option.value);
                                    break;

                                case 'create-option':
                                    console.debug("create", option);
                                    this.addAccount(option.value);
                                    break;
                            }
                        }
                        }
                    />
                </div>
                <span style={{ fontSize: 12 }}>You can search for a user, or enter a new email address to create a new user.</span>

                {this.account
                    ? <React.Fragment>

                        <hr className="mb-5" />


                        <div className="row mb-2"><div className="col-3"><label className="text-muted" >Name</label></div><div className="col-9">
                            <input className="form-control form-control-sm" type="text" value={this.account.Name} readOnly={true} />
                        </div></div>
                        <div className="row mb-2"><div className="col-3"><label className="text-muted" >Email</label></div><div className="col-9">
                            <input className="form-control form-control-sm" type="text" readOnly={true} value={this.account.Email} />
                        </div></div>

                        <h6 className="text-normal text-uppercase"></h6>

                        <div className="row mb-2"><div className="col-3"><label className="text-muted" >Actions</label></div><div className="col-9">
                            <button className="btn btn-success btn-sm mr-1" onClick={this.addCustomers}>Add customer</button>
                            <button className="btn btn-success btn-sm" onClick={this.toggleSendEmail} disabled={this.sendInvitationButton.disabled}>{this.sendInvitationButton.text}</button>
                        </div></div>
                        { /* Start: Send email*/
                        }

                        <Modal open={this.showSendEmail}
                            close={() => { this.showSendEmail = false; }}
                            ok={() => {
                                this.sendInvitation();
                            }}
                            title={"Send invitation "}>
                            <div className="row mb-2"><div className="col-3"><label className="text-muted" >Email</label></div><div className="col-9">
                                <label className="text-muted" htmlFor="textarea-input">Optional message</label>

                                <textarea className="form-control text-muted" id="textarea-input" rows="5"
                                    name="message"
                                    value={this.message}
                                    onChange={(e) => this.updateMessage(e)}
                                ></textarea>
                            </div></div>
                        </Modal>


                        { /* Start: Add new customers */
                        }
                        {this.showAddCustomers
                            ? <div>
                                <div className="card mt-4">
                                    <div className="card-body">
                                        <div className="form-group">
                                            <label htmlFor="search-customers">Add customers to user account</label>
                                            <input className="form-control" type="text" id="search-customers"
                                                autoFocus={true}
                                                onChange={(e) => this.handleCustomerSearchValue(e)}
                                                value={this.customerSearchValue}
                                            />
                                            {this.customerSearchResult.length == 0
                                                ? <small className="form-text text-muted">
                                                    <ol className="list-unstyled">
                                                        <li><span className="text-primary text-medium">1. </span>Type in customer name or number to search...</li>
                                                        <li><span className="text-primary text-medium">2. </span>Pick customers in the search result.</li>
                                                        <li><span className="text-primary text-medium">3. </span>You can perform multiple searches to add more...</li>
                                                    </ol>
                                                </small>
                                                : ""}
                                        </div>

                                        {this.customerSearchResult.length > 0
                                            ? <div className="form-group">
                                                <label>Search result</label>
                                                <div className="table-responsive text-sm">
                                                    <table className="table margin-bottom-none">
                                                        <thead>
                                                            <tr>
                                                                <th>Customer</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>


                                                            {this.customerSearchResult.slice().map((company) => (
                                                                <tr key={company.Id}>
                                                                    <td className="align-middle">{company.Name} ({company.Number}), {company.City}</td>
                                                                    <td className="align-middle">
                                                                        {this.isSelected(company)
                                                                            ? <button className="btn btn-success btn-sm mt-0"
                                                                                disabled={true}><i className="iziToast-icon material-icons check"></i></button>
                                                                            : <button className="btn btn-success btn-sm mt-0"
                                                                                onClick={() => this.toggleCompany(company)}>Add</button>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            : ""}
                                        <div className="float-right">
                                            <button className="btn btn-success btn-sm" onClick={this.hideAddCustomers}>Done adding customers</button>
                                        </div>

                                    </div>

                                </div>

                            </div>
                            : ""}
                        { /* End: Add new customers */}

                        <div className="text-sm">

                            {this.account && this.account.Customers.map(customer => [

                                <div className="row mb-4" key={customer.Id + "_row1"}>
                                    <div className="col-12"><h6 style={{ display: "inline-block" }}>{customer.Name} ({customer.Number}), {customer.City}</h6><a onClick={() => { this.deleteCustomer(customer) }}>[Delete]</a></div>

                                    <div className="col-12 align-middle">
                                        Role:
                                        
                                        <select
                                            value={customer.Role}
                                            onChange={(e) => { this.onChangeRole(customer.Id, e.target.value) }}
                                        >
                                            {customer.AvailableRoles && customer.AvailableRoles.map((role, roleIndex) => {
                                                return (
                                                    <option
                                                        key={role}
                                                        value={role}>{role}</option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </div>,
                                <div className="row mb-3" key={customer.Id + "_row2"}>

                                    <div className="col-12" colSpan="3">

                                        {customer.Addresses && customer.Addresses.map(address => {

                                            const shippingName = address.AddressName.replace("Shipping-", "");


                                            return (<div className="text-xs" key={shippingName}>
                                                <div className="custom-control custom-checkbox">
                                                    <input className="custom-control-input" type="checkbox" id={"cb" + shippingName}
                                                        onChange={(e) => this.toggleAddress(address, e.target.checked)}
                                                        checked={address.Active}
                                                    />
                                                    <label className="custom-control-label" htmlFor={"cb" + shippingName}>
                                                        <strong>#{shippingName}</strong>{address.FirstName + (address.FirstName !== null && " ") + address.LastName} {address.Line1} {address.Line1 && ","} {address.Line2}, {address.PostalCode} {address.City}
                                                    </label>
                                                </div>

                                            </div>);
                                        })}
                                    </div>
                                </div>]
                            )}


                        </div>

                    </React.Fragment>
                    : ""}


            </div>);

    }
}